import React from "react";

interface IPageItemSeparatorProps {}

export class Separator extends React.PureComponent<IPageItemSeparatorProps> {
  render() {
    const baseClass = "el-pagination-list__item";

    return (
      <li className={baseClass}>
        <span> ... </span>
      </li>
    );
  }
}
